var map = {
	"./collage-0.jpg": 70732,
	"./collage-1.jpg": 45536,
	"./collage-1029w-0.jpg": 52294,
	"./collage-2.jpg": 48785,
	"./collage-3.jpg": 99350,
	"./collage-4.jpg": 23850,
	"./collage-503w-2.jpg": 71236,
	"./collage-503w-4.jpg": 28662
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68455;